<style lang="scss" scoped>

.fade-enter-active,
.fade-leave-active {
    transition: all 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    transform: translateY(-20%);
    opacity: 0;
}

</style>

<template>
    <Modal ref="modal">
        <template v-slot:title>
            <span>Fehlende Angaben nachtragen</span>
        </template>
        
        <div v-if="!isProfileWaterPoint" class="row mt-1 mb-3">
            <div class="col-12">
                <label class="form-label">
                    Entnahmestelle
                </label>
                <WaterPointSelect v-model:waterPointId="waterPointId" :disabled="isProfileWaterPoint" referrer="/withdrawal?action=missingdatamodal"></WaterPointSelect>
            </div>
        </div>
       
       <Alert type="danger" :show="alert.waterPoint" :timeout="6000">
            <template v-slot:title>Entnahmestelle fehlt</template>
            Bitte wählen Sie eine Entnahmestelle
       </Alert>
       
       <div v-if="!profile.area" class="row mt-3 mb-2">
            <div class="col-12">
                <label class="form-label">Schlagfläche in Hektar</label>
                <FloatInput v-model:value="area" :imaskOptions="{mask:'0[00]{,}000 h\\a',overwrite: true, eager: true, lazy: false}"
                :digits="3" placeholder="Fläche des Schlags in ha" :disabled="false" >
                </FloatInput>
            </div>           
        </div>
        
        <Alert type="danger" :show="alert.areaEmpty" :timeout="3000">
            <template v-slot:title>Schlagfläche fehlt</template>
            Bitte geben Sie die Schlagfläche in Hektar an. Bitte beachten Sie, dass die Schlagfläche später nicht mehr verändert werden kann
        </Alert> 
        
        <Alert type="danger" :show="alert.area">
            <template v-slot:title>Bitte bachten Sie</template>
                Die Schlagfläche kann später nicht mehr verändert werden. Wenn Sie sicher sind, dass 
                die Eingabe der Größe des Schlages von <b>{{ area ? area.toFixed(3).replace('.',',') : '' }} ha</b> korrekt ist,
                klicken Sie bitte erneut auf „Speichern“.
        </Alert>
        
        <!-- Modal Footer -->       
        <template v-slot:footer>
                <button type="button" class="btn me-auto" @click="closeModal">
                    Abbrechen
                </button>
                <a href="#" class="btn btn-info ms-auto" @click="submit">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                      <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" />
                      <polyline points="7 11 12 16 17 11" />
                      <line x1="12" y1="4" x2="12" y2="16" /> 
                    </svg>
                    Speichern
                </a>            
        </template>
    </Modal>
</template>

<script>
import * as dayjs from 'dayjs';
import MinMax from 'dayjs/plugin/minMax';
dayjs.extend(MinMax)

import Modal from '@/components/Modal.vue';
import Alert from '@/components/Alert.vue';
import FloatInput from '@/components/input/FloatInput.vue';
import WaterPointSelect from '@/components/waterpoint/WaterPointSelect.vue';


export default {
    name: 'Missing Data Modal',
    components: {
        Modal,
        Alert,
        WaterPointSelect,
        FloatInput
    },
    inject: [
        'state',
        'config'
    ],
    props: {
        profile: {
            type: Object,
            default: undefined
        }
    },
    data: function () {
        return {
            waterPointId: null,
            area: null,
            alert: {
                waterPoint: false,
                area: false,
                areaEmpty: false,
            }
        }
    },
    computed: {
        isWaterPointSelected: function () {
            return !(this.waterPointId == null);          
        },
        isProfileWaterPoint: function () {
            return !(this.profile.waterPointId == null);          
        },
    },
    methods: {
        openModal: function () {
            this.$nextTick(function() { 
                this.$refs.modal.openModal();        
            });
        },
        closeModal: function () {
            this.$refs.modal.closeModal();                   
        },
        submit: function () {
            if (!this.validateForm()) {
                return
            }
            const waterPointId =  this.waterPointId ? this.waterPointId: null;
            const area =  this.area ? Math.round(this.area * 10000.0) : null;
            
            this.closeModal();
            this.$emit('submit', waterPointId, area);
        },
        validateForm: function () {
            this.alert.waterPoint = false;
            if ( !this.isProfileWaterPoint && !this.waterPointId ) {
                this.$nextTick(function() { 
                    this.alert.waterPoint = true;
                });
                return false;
            }
            
            this.alert.areaEmpty = false;
            if (!this.profile.area && !this.area ) {
                this.$nextTick(function() { 
                    this.alert.areaEmpty = true;
                });
                return false;
            }
           
            if (!this.profile.area && this.alert.area === false) {
                this.$nextTick(function() { 
                    this.alert.area = true;
                 });
                return false;
            }
            return true;
        }
    },
    watch: {
    
    },
    created: function () {
    
    },
    mounted: function () {
        
    }
}

</script>